// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fs18[data-v-4c041cb2] {\n  font-size: 19px;\n  line-height: 28px;\n}\n[data-v-4c041cb2] .el-popover {\n  padding: 12px 0 12px 0;\n}\n[data-v-4c041cb2] .el-divider--horizontal {\n  margin: 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
